import {AfterViewInit, Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {DomSanitizer, SafeResourceUrl} from '@angular/platform-browser';
import {ProfileService} from '../service/profile.service';
import {PageHtml5DTO} from '@tj/tj-dmp-lib-api';
import {environment} from '../../../../environments/environment';

@Component({
    // tslint:disable-next-line:component-selector
    selector: 'dmp-iframe',
    templateUrl: './iframe.component.html',
    styleUrls: ['./iframe.component.scss'],
    standalone: false
})
export class IframeComponent implements AfterViewInit, OnChanges, OnInit {
    /** contenu HTML */
    @Input() contentHtml: string;
    /** lien web */
    @Input() src: string;
    /** pageHtml5 */
    @Input() pageHtml5: PageHtml5DTO;
    /**
     * pixels or %    the size of the width
     */
    @Input() width: string;
    /**
     * pixels or %    the size of the height
     */
    @Input() height = '800px';
    /**
     * 'mobile' 'tablette' 'desktop'
     */
    @Input() displayDevice: string;

    urlPreview: SafeResourceUrl;

    private iWindow: Window;

    private readonly key = 'previewDisplayDevice';

    constructor(
        protected sanitizer: DomSanitizer,
        protected profileService: ProfileService
    ) {
        const value = localStorage.getItem(this.key);
        if (value == null) {
            this.savedDisplayDevice('desktop');
        }
        {
            this.displayDevice = value;
        }
    }

    private savedDisplayDevice(displayDevice: string = null) {
        if (displayDevice) {
            this.displayDevice = displayDevice;
        }
        localStorage.setItem(this.key, this.displayDevice);
    }

    ngOnInit(): void {
        this.changeScreen();
        if (this.src) {
            this.updateIframe();
        }
    }

    private initPageHtml5() {
        if (this.pageHtml5) {
            const src = `${environment.landingPagePreviewBaseUrl}/${this.profileService.getDatastore()}/TEST?pageHtml=${this.pageHtml5.code}&lang=FR`;
            this.urlPreview = this.sanitizer.bypassSecurityTrustResourceUrl(src);
            const iframe = document.getElementById('iframe') as HTMLIFrameElement;
            iframe.addEventListener('load', () => {
                this.iWindow = iframe.contentWindow;
            });
        }
    }

    ngAfterViewInit() {
        this.initPageHtml5();
        if (this.contentHtml) {
            this.updateIframe();
        }
    }

    private updateIframe() {
        const iframe = document.getElementById('iframe');
        if (this.src) {
            this.urlPreview = this.sanitizer.bypassSecurityTrustResourceUrl(this.src);
        } else if (this.contentHtml && iframe) {
            const doc = (iframe as HTMLIFrameElement).contentWindow.document;
            doc.open();
            doc.write(this.contentHtml);
            doc.close();
        } else if (this.pageHtml5 && this.iWindow) {
            this.iWindow.postMessage(this.pageHtml5, '*');
        }
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.contentHtml || changes.src || changes.pageHtml5) {
            this.updateIframe();
        }
        if (changes.displayDevice) {
            this.changeScreen();
        }
    }

    changeScreen(
        displayDevice: string = this.displayDevice,
        event: Event = null
    ) {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        this.displayDevice = displayDevice;
        switch (displayDevice) {
            case 'mobile':
                this.width = '320px';
                break;
            case 'tablette':
                this.width = '480px';
                break;
            case 'desktop':
            default:
                this.width = '100%';
                break;
        }
    }

    isTablette() {
        return this.displayDevice === 'tablette';
    }

    isMobile() {
        return this.displayDevice === 'mobile';
    }

    isDesktop() {
        return this.displayDevice === 'desktop' || this.displayDevice == null;
    }
}
